<template>
    <div>
        <navbar-component :color="color" :flat="flat"/>
        <v-main class="pt-0">
        <index-component/>
        <about-component/>
        <catalog-component/>
        <contact-component/>
        </v-main>
        <footer-component/>
        <v-scale-transition>
        <v-btn v-show="fab" v-scroll="onScroll" fab href="https://wa.me/527713497113?text=Hola Necesito una cotización" target="_blank" dark fixed bottom right color="success" @click="toTop">
            <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
        </v-scale-transition>
    </div>
</template>

<script>
import AboutComponent from '../components/landing/AboutComponent.vue'
import CatalogComponent from '../components/landing/CatalogComponent.vue'
import ContactComponent from '../components/landing/ContactComponent.vue'
import FooterComponent from '../components/landing/FooterComponent.vue'
import IndexComponent from '../components/landing/IndexComponent.vue'
import NavbarComponent from '../components/NavbarComponent.vue'
export default {
    name:'layout_main',
    components: {  IndexComponent, AboutComponent, CatalogComponent, ContactComponent, FooterComponent, NavbarComponent },
    metaInfo: {
    title: 'José Santiago'
    },
    data: () => ({
    fab:null,
    color:null,
    flat:null,
    activeItem:'home',
    clr:false
  }),
  
  watch:{
    fab(value) {
      if (value) {
        this.color = "success";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },
  methods:{
    onScroll(e){
            if (typeof window === "undefined") return;
            const top = window.pageYOffset || e.target.scrollTop || 0;
            this.fab = top > 60;

    },
    toTop(e){
            this.$vuetify.goTo(0);
    },
  },
  created(){
      const top = window.pageYOffset || 0;
      if (top <= 60) {
        this.color = "transparent";
        this.flat = true;
      }
  }
  
};
</script>
<style scoped>

.v-main {
  background-image: url("~@/assets/img/bgMain.png");
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}

  
.v-btn {
    letter-spacing: normal;
}
</style>
